/**
 * mixology.js (Simplified Version)
 * - No sliders, no percentages, no mix validation
 * - User selects ONE brand + ONE fragrance
 * - Scent has a name field
 * - Cart item properties include brand, fragrance, scent name
 * - Cart item title is rewritten as:
 *   "Mixit Customized - BRAND - FRAGRANCE"
 */

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".mixology-section").forEach((section) => {
    const form = section.querySelector(".mixology-form");
    const addButton = section.querySelector(".mix-add-btn");
    const errorBox = section.querySelector(".mix-error");
    const mixVariantInput = section.querySelector("#mix-product-variant");

    // The ONLY slot we keep
    const slot = section.querySelector(".mix-slot");

    const vendorSelect = slot.querySelector(".vendor-select");
    const productSelect = slot.querySelector(".product-select");

    // -------------------------------------------
    //  BRAND → LOAD PRODUCTS
    // -------------------------------------------
    function loadProductsForBrand(brand) {

      const lang = (document.documentElement.lang || '').toLowerCase();
    const isArabic = lang === 'ar' || lang.startsWith('ar-');
    const selectText  = isArabic ? 'حدد العطر' : 'Select Fragrance';

      productSelect.innerHTML = `<option value="">${selectText}</option>`;

      const products = productsByBrand[brand] || [];

      if (!products.length) {
        productSelect.innerHTML = `<option value="">No active fragrances</option>`;
        productSelect.disabled = true;
        return;
      }

      products.forEach((p) => {
        const opt = document.createElement("option");
        opt.value = p.handle;
        opt.textContent = p.title;
        opt.dataset.prodId = p.id;
        opt.dataset.vendor = brand;
        productSelect.appendChild(opt);
      });

      productSelect.disabled = false;
    }

    vendorSelect.addEventListener("change", () => {
      

      const brand = vendorSelect.value;
      productSelect.disabled = true;
      productSelect.innerHTML = `<option value="">Select Fragrance</option>`;

      if (!brand) {
        addButton.disabled = true;
        return;
      }

      loadProductsForBrand(brand);
      validateForm();
    });

    productSelect.addEventListener("change", () => {
      validateForm();
    });

    // -----------------------------
    // VALIDATION: brand + fragrance
    // -----------------------------
    function validateForm() {
      const brand = vendorSelect.value.trim();
      const fragrance = productSelect.value.trim();

      addButton.disabled = !(brand && fragrance);
      errorBox.textContent = "";

      if (!brand || !fragrance) return false;
      return true;
    }

    // -----------------------------
    // FORM SUBMIT → ADD TO CART
    // -----------------------------
    form.addEventListener("submit", (e) => {
      e.preventDefault();

      if (!validateForm()) return;

      const mixVariant = mixVariantInput.value?.trim();
      if (!mixVariant) {
        errorBox.textContent =
          "Mix product variant ID missing. Please configure section settings.";
        return;
      }

      // Ensure variant id field exists
      let idInput = form.querySelector('input[name="id"]');
      if (!idInput) {
        idInput = document.createElement("input");
        idInput.type = "hidden";
        idInput.name = "id";
        form.appendChild(idInput);
      }
      idInput.value = mixVariant;

      // Read fields
      const brand = vendorSelect.value.trim();
      const fragranceOption =
        productSelect.options[productSelect.selectedIndex];
      const fragranceName = fragranceOption.textContent.trim();

      const scentNameField = form.querySelector(
        'input[name="properties[Name Your Scent]"]'
      );
      const scentName = scentNameField?.value.trim() || "";

      const scentMessageField = form.querySelector(
        'input[name="properties[Message]"]'
      );
      const scentMessage = scentMessageField?.value.trim() || "";

      /* Remove all previous properties
      form.querySelectorAll('[name^="properties["]').forEach((el) =>
        el.remove()
      );*/

      // ---- Add NEW properties ----
      function addProp(label, value) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${label}]`;
        input.value = value;
        form.appendChild(input);
      }

      addProp("Brand", brand);
      addProp("Fragrance", fragranceName);

      if (scentName) addProp("Name Your Scent", scentName);
      if (scentMessage) addProp("Message Text", scentMessage);

      // ----------------------
      // CUSTOM CART ITEM TITLE
      // ----------------------
      addProp(
        "Custom Title",
        `Mixit Customized - ${brand} - ${fragranceName}`
      );

      // ----------------------
      // AJAX SUBMIT
      // ----------------------
      const formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      })
        .then((r) => {
          if (!r.ok) throw r;
          return r.json();
        })
        .then(() => {
          window.location.href = "/cart";
        })
        .catch(() => {
          errorBox.textContent = "Failed to add to cart.";
        });
    });

    // Initial
    validateForm();
  });
});